import { render, staticRenderFns } from "./RoundNavigation.vue?vue&type=template&id=040bbae2&scoped=true&"
import script from "./RoundNavigation.vue?vue&type=script&lang=js&"
export * from "./RoundNavigation.vue?vue&type=script&lang=js&"
import style0 from "./RoundNavigation.vue?vue&type=style&index=0&id=040bbae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040bbae2",
  null
  
)

export default component.exports